import { __require as requireStylis } from '../node_modules/stylis/dist/umd/stylis.js';

var stylisExports = requireStylis();

export { stylisExports as default };
//# sourceMappingURL=stylis.js.map
